import classNames from 'classnames/bind';
import style from "./styles.pcss";
var cn = classNames.bind(style);
var tooltipPropDirection = ['upLeft', 'upCenter', 'upRight', 'downLeft', 'downCenter', 'downRight', 'leftUp', 'leftCenter', 'leftDown', 'rightUp', 'rightCenter', 'rightDown'];
var handleClick = function handleClick(e) {
  e.preventDefault();
};
var DEFAULT_DIRECTION = 'upLeft';
export var dataConverter = function dataConverter(props) {
  var _props$direction = props.direction,
    direction = _props$direction === void 0 ? DEFAULT_DIRECTION : _props$direction,
    _props$text = props.text,
    text = _props$text === void 0 ? 'реклама' : _props$text,
    _props$textBadge = props.textBadge,
    textBadge = _props$textBadge === void 0 ? 'рекламодатель — ПАО «ВымпелКом»' : _props$textBadge,
    _props$color = props.color,
    color = _props$color === void 0 ? 'tertiary-invert' : _props$color,
    _props$theme = props.theme,
    theme = _props$theme === void 0 ? 'light' : _props$theme,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$portalClassNam = props.portalClassName,
    portalClassName = _props$portalClassNam === void 0 ? '' : _props$portalClassNam,
    _props$tooltipClassNa = props.tooltipClassName,
    tooltipClassName = _props$tooltipClassNa === void 0 ? '' : _props$tooltipClassNa,
    containerRef = props.containerRef,
    shouldClose = props.shouldClose;
  // исправляем значение direction на случай опечатки
  var correctDirection = tooltipPropDirection.find(function (el) {
    return el === direction;
  }) || DEFAULT_DIRECTION;
  return {
    onClick: handleClick,
    size: 'l',
    className: className,
    color: color,
    label: text,
    children: textBadge,
    popoverProps: {
      portalClassName: cn('portal', portalClassName),
      container: containerRef,
      className: tooltipClassName,
      closureModes: {
        scroll: true,
        viewport: true
      }
    },
    background: theme,
    tooltipDirection: correctDirection,
    shouldClose: shouldClose
  };
};